import { useCallback, useState } from "react";
import axiosInstance from "@/services/api";
import { SlugCheckResponse } from "../../types";

export const useCheckSlugAvailability = (
  checkEndpoint: (slug: string) => string
) => {
  const [isLoading, setIsLoading] = useState(false);

  // `useCallback`-wrapped so callers relying on this as a dependency (e.g.
  // `useSlugChecker`'s `handleCheck`) don't get a new identity every render
  // — an unmemoized `checkSlug` here was cascading into effects re-running
  // far more often than their own dependencies actually changed.
  const checkSlug = useCallback(
    async (slug: string): Promise<SlugCheckResponse> => {
      setIsLoading(true);
      try {
        const url = checkEndpoint(slug);
        const response = await axiosInstance.get<SlugCheckResponse>(url);
        return response.data;
      } finally {
        setIsLoading(false);
      }
    },
    [checkEndpoint]
  );

  return {
    checkSlug,
    isLoading,
  };
};
